<script lang="ts">
	import { page } from '$app/state';

	import LucideHome from '~icons/lucide/home';
	import LucideNotebookText from '~icons/lucide/notebook-text';
	import LucideCodeXml from '~icons/lucide/code-xml';
</script>

<ul class="flex items-center gap-2 sm:gap-2">
	<li>
		<a href="/" class:active={page.url.pathname === '/'}
			><LucideHome class="h-6 w-6 sm:h-5 sm:w-5"></LucideHome>Home</a
		>
	</li>
	<li>
		<a href="/projects" class:active={page.url.pathname === '/projects'}>
			<LucideCodeXml class="h-6 w-6 sm:h-5 sm:w-5"></LucideCodeXml>
			<span class="hidden sm:inline-block">Projects</span></a
		>
	</li>
	<li>
		<a href="/blog" class:active={page.url.pathname === '/blog'}>
			<LucideNotebookText class="h-6 w-6 sm:h-5 sm:w-5"></LucideNotebookText><span
				class="hidden sm:inline-block">Blog</span
			></a
		>
	</li>
</ul>

<style lang="postcss">
	a {
		@apply relative flex items-center gap-1 rounded-lg p-2 text-gray-800 no-underline hover:text-gray-900 hover:after:bg-gray-300/50 dark:text-gray-100 dark:hover:text-gray-200 dark:hover:after:bg-gray-800;
	}

	a::after {
		@apply absolute inset-0 -z-20 rounded-lg bg-[#00000000] transition-colors duration-200 ease-out;
		pointer-events: none;
		content: '';
	}

	a::before {
		@apply pointer-events-none absolute inset-0 border-transparent transition-colors;
		content: '';
	}

	.active {
		@apply before:absolute before:inset-0 before:border-b-2 before:border-gray-500 before:content-[""] before:dark:border-gray-300/80;
	}
</style>
